import { ChangeDetectionStrategy, Component } from '@angular/core'
import { MatTabsModule } from '@angular/material/tabs'
import { RouterLink, RouterLinkActive } from '@angular/router'

import { TranslateModule } from '@ngx-translate/core'

import { ANALYST_COVERAGE_PATH, MARKET_CAP_PATH, SECTOR_PATH } from '../../constants'

@Component({
  selector: 'app-performance-navigation',
  templateUrl: './performance-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, MatTabsModule, TranslateModule, RouterLinkActive],
})
export class PerformanceNavigationComponent {
  SECTOR_PATH = SECTOR_PATH
  MARKET_CAP_PATH = MARKET_CAP_PATH
  ANALYST_COVERAGE_PATH = ANALYST_COVERAGE_PATH
}
